import { ToolPageShell } from '@/shared/seo'
import { VosstanovitPdfForm } from './VosstanovitPdfForm'

export function VosstanovitPdfPage() {
  return (
    <ToolPageShell utilityKey="repair-pdf">
      <VosstanovitPdfForm />
    </ToolPageShell>
  )
}
